import { IProvenancesStore } from '../index'
import { IDeletedProvenance } from '../../../actions/provenances/deleteProvenance'

export default function(
  state: IProvenancesStore,
  action: IDeletedProvenance,
): IProvenancesStore {
  return {
    ...state,
    provenances: [
      ...state.provenances.map(provenance => {
        if (provenance.id === action.provenanceId) {
          return {
            ...provenance,
            isDeleted: true,
          }
        } else {
          return provenance
        }
      }),
    ],
  }
}
